/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { createColorsContext } from "@superweb/ui";

export type PartnerLoyaltyColors = {
  goldGradient: string;
  silverGradient: string;
  bronzeGradient: string;
  basicGradient: string;
  gold: string;
  silver: string;
  bronze: string;
  basic: string;
  platinum: string;
};

const [PartnersLoyaltyColors, usePartnersLoyaltyColors] =
  createColorsContext<PartnerLoyaltyColors>({
    light: {
      goldGradient: `radial-gradient(circle at 0% -10%, #F3C978 20%, transparent 50%),
    radial-gradient(circle at 140% 90%, #EFB55E 20%, transparent 50%),
    radial-gradient(circle at 60% 30%, #FFC46B 20%,  #D89430 70%)`,
      silverGradient: `radial-gradient(circle at -20% -10%, #F2F1EF 2%, transparent 50%),
    radial-gradient(circle at 120% 110%, #E8E6E3 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #696969 20%,  #ACACAC 90%)`,
      bronzeGradient: `radial-gradient(circle at 0% -30%, #FBC8C5 2%, transparent 50%),
    radial-gradient(circle at 100% 130%, #F7BCB6 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #88545A 20%,  #B67A79 80%)`,
      basicGradient: `radial-gradient(circle at -10% -20%, #aeccde 2%, transparent 50%),
    radial-gradient(circle at 100% 120%, #8cafce 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #536c8a 20%,  #5a799c 60%)`,
      gold: "#C88A37",
      silver: "#959593",
      bronze: "#A06C6C",
      platinum: "#4F6A8D",
      basic: "#45586E",
    },
    dark: {
      goldGradient: `radial-gradient(circle at 0% -10%, #F3C978 20%, transparent 50%),
    radial-gradient(circle at 140% 90%, #EFB55E 20%, transparent 50%),
    radial-gradient(circle at 60% 30%, #FFC46B 20%,  #D89430 70%)`,
      silverGradient: `radial-gradient(circle at -20% -10%, #F2F1EF 2%, transparent 50%),
    radial-gradient(circle at 120% 110%, #E8E6E3 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #696969 20%,  #ACACAC 90%)`,
      bronzeGradient: `radial-gradient(circle at 0% -30%, #FBC8C5 2%, transparent 50%),
    radial-gradient(circle at 100% 130%, #F7BCB6 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #88545A 20%,  #B67A79 80%)`,
      basicGradient: `radial-gradient(circle at -10% -20%, #aeccde 2%, transparent 50%),
    radial-gradient(circle at 100% 120%, #8cafce 2%, transparent 50%),
    radial-gradient(circle at 60% 30%, #536c8a 20%,  #5a799c 60%)`,
      gold: "#EBB361",
      silver: "#BCBAB8",
      bronze: "#C9918C",
      basic: "#7999B6",
      platinum: "#4F6A8D",
    },
  });

export { PartnersLoyaltyColors, usePartnersLoyaltyColors };
